import React from 'react';

import SmartTag from './SmartTag.jsx';

class SmartTags extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      new_id: '',
      new_title: '',
      new_autocomplete: '',
      new_values: null,
    };

    this.getSmartTag = this.getSmartTag.bind(this);
    this.smartTagChange = this.smartTagChange.bind(this);
  }

  componentWillMount() {
    if (!this.state.loaded) {
      this.props.loadSmartTags();
      this.setState({ loaded: true });
    }
  }

  getSmartTag(idx) {
    return this.props.smartTags[idx] !== 'undefined'
      ? this.props.smartTags[idx]
      : null;
  }

  smartTagChange(idx, smartTag) {
    this.props.smartTagChange(idx, smartTag);
  }

  idOnChange(idx, val) {
    let smartTag = this.getSmartTag(idx);
    smartTag.id = val;
    this.smartTagChange(idx, smartTag);
  }

  titleOnChange(idx, val) {
    let smartTag = this.getSmartTag(idx);
    smartTag.title = val;
    this.smartTagChange(idx, smartTag);
  }

  autocompleteOnChange(idx, val) {
    let smartTag = this.getSmartTag(idx);
    smartTag.autocomplete = val;
    this.smartTagChange(idx, smartTag);
  }

  valueIdOnChange(idx, val_idx, val) {
    let smartTag = this.getSmartTag(idx);
    let values = smartTag.values;
    values[val_idx].id = val;
    smartTag.values = values;
    this.smartTagChange(idx, smartTag);
  }

  valueTitleOnChange(idx, val_idx, val) {
    let smartTag = this.getSmartTag(idx);
    let values = smartTag.values;
    values[val_idx].title = val;
    smartTag.values = values;
    this.smartTagChange(idx, smartTag);
  }

  valueRemove(idx, val_idx) {
    let smartTag = this.getSmartTag(idx);
    let values = smartTag.values;
    values.splice(val_idx, 1);
    smartTag.values = values;
    this.smartTagChange(idx, smartTag);
  }

  valueAddNew(idx, id, title) {
    let smartTag = this.getSmartTag(idx);
    let values = smartTag.values || [];
    values.push({
      id: id,
      title: title,
    });
    smartTag.values = values;
    this.smartTagChange(idx, smartTag);
  }

  newIdOnChange(idx, val) {
    this.setState({ new_id: val });
  }

  newTitleOnChange(idx, val) {
    this.setState({ new_title: val });
  }

  newAutocompleteOnChange(idx, val) {
    this.setState({ new_autocomplete: val });
  }

  newValueIdOnChange(idx, val_idx, val) {
    let values = this.state.new_values;
    values[val_idx].id = idx;
    this.setState({ new_values: values });
  }

  newValueTitleOnChange(idx, val_idx, val) {
    let values = this.state.new_values;
    values[val_idx].title = idx;
    this.setState({ new_values: values });
  }

  newValueRemove(idx, val_idx) {
    let values = this.state.new_values;
    values.splice(val_idx, 1);
    this.setState({ new_values: values });
  }

  newValueAddNew(idx, id, title) {
    let values = this.state.new_values || [];
    values.push({
      id: id,
      title: title,
    });
    this.setState({ new_values: values });
  }

  addNewSmartTag() {
    if (this.state.new_id !== '' && this.state.new_title !== '') {
      let smart_tag = {
        id: this.state.new_id,
        title: this.state.new_title,
      };
      if (this.state.new_autocomplete !== '') {
        smart_tag['autocomplete'] = this.state.new_autocomplete;
      }
      if (this.state.new_values) {
        smart_tag['values'] = this.state.new_values;
      }
      this.props.smartTagAdd(smart_tag);
      this.setState({
        new_id: '',
        new_title: '',
        new_autocomplete: '',
        new_values: null,
      });
    }
  }

  removeSmartTag(idx) {
    this.props.smartTagRemove(idx);
  }

  save() {
    this.props.save();
  }

  render() {
    let smartTags, savedSmartTags;

    if (this.props.smartTags) {
      smartTags = this.props.smartTags.map((smartTag, idx) => {
        return (
          <SmartTag
            key={idx}
            idx={idx}
            id={smartTag.id}
            title={smartTag.title}
            autocomplete={smartTag.autocomplete}
            values={smartTag.values}
            idOnChange={this.idOnChange.bind(this)}
            titleOnChange={this.titleOnChange.bind(this)}
            autocompleteOnChange={this.autocompleteOnChange.bind(this)}
            valueIdOnChange={this.valueIdOnChange.bind(this)}
            valueTitleOnChange={this.valueTitleOnChange.bind(this)}
            valueRemove={this.valueRemove.bind(this)}
            valueAddNew={this.valueAddNew.bind(this)}
            removeSmartTag={this.removeSmartTag.bind(this)}
          />
        );
      });
    }

    return (
      <div>
        {smartTags}
        <SmartTag
          idx="0"
          id={this.state.new_id}
          title={this.state.new_title}
          autocomplete={this.state.new_autocomplete}
          values={this.state.new_values}
          idOnChange={this.newIdOnChange.bind(this)}
          titleOnChange={this.newTitleOnChange.bind(this)}
          autocompleteOnChange={this.newAutocompleteOnChange.bind(this)}
          valueIdOnChange={this.newValueIdOnChange.bind(this)}
          valueTitleOnChange={this.newValueTitleOnChange.bind(this)}
          valueRemove={this.newValueRemove.bind(this)}
          valueAddNew={this.newValueAddNew.bind(this)}
          is_new="true"
          addNewSmartTag={this.addNewSmartTag.bind(this)}
        />
        <div className="row">
          <div className="col-md-12 text-center add-new-widget-container">
            <button className="btn btn-success" onClick={this.save.bind(this)}>
              <i className="fa fa-floppy-o" />
              &nbsp;Uložiť povolené typy Smart tagov
            </button>
            <div className="clearfix">&nbsp;</div>
          </div>
        </div>
      </div>
    );
  }
}

export default SmartTags;



// WEBPACK FOOTER //
// ./src/js/app/admin/SmartTags.jsx